import styled, { keyframes, css } from 'styled-components';

const rotate = keyframes`
  from {
    transform: translateY(-50%) rotate(0deg);
  }
  to {
    transform: translateY(-50%) rotate(360deg);
  }
  `;

export const CustomInputWrapper = styled.div<any>`
  display: flex;
  background: #ffffff;
  border: 1px solid #e0e2e8;
  box-sizing: border-box;
  border-radius: 10px;
  height: 56px;
  position: relative;

  &.-focused {
    border: 1px solid var(--primary);
  }

  &.-error {
    border-color: #d91e1e;
    /* background: rgba(217, 30, 30, 0.2); */

    label {
      color: #d91e1e;
    }
  }

  &.-loading {
    opacity: 0.5;
    position: relative;

    ::after {
      content: '';
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(-50%);
      width: 24px;
      height: 24px;
      border: 1px solid var(--primary);
      border-radius: 50%;
      z-index: 199;
      animation: ${rotate} 2s linear infinite;
    }

    ::before {
      content: '';
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(-50%);
      width: 26px;
      height: 26px;
      border: 4px solid var(--primary);
      border-left: 4px solid transparent;
      border-right: 4px solid transparent;
      border-bottom: 4px solid transparent;
      border-radius: 50%;
      z-index: 199;
      animation: ${rotate} 2s linear infinite;
    }
  }
  @media screen and (max-width: 740px) {
    height: 48px;
  }

  // error
  span,
  .error {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    color: red;
    font-size: 10px;
  }
`;

export const Input = styled.input<any>`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  border: 0px solid transparent;
  background: transparent;
  font-size: 16px;
  color: #000000;
  padding: 14px 20px 0;
  font-family: 'frutiger';


  ${({ password }) =>
    password &&
    css`
      padding: 14px 38px 0 20px;
    `}
  @media screen and (max-width: 740px) {
    font-size: 14px;
    padding: 14px 12px 0;

    ${({ password }) =>
      password &&
      css`
        padding: 14px 38px 0 12px;
      `}
  }
`;

export const InputLabel = styled.label`
  font-size: 14px;
  color: #717785;
  position: absolute;
  top: 50%;
  left: 20px;
  transform: translateY(-50%);
  transition: 0.25s;
  text-transform: capitalize;
  line-height: 1;
  cursor: auto;

  &.-focused {
    top: 8px;
    font-weight: 500;
    font-size: 12px;
    transform: translateY(0%);
  }
  &.focus {
    color: var(--primary-dark);
  }
  @media screen and (max-width: 740px) {
    left: 12px;
    font-size: 12px;
    &.-focused {
      font-size: 10px;
    }
  }
`;

export const ShowPasswordText = styled.div`
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);
  cursor: pointer;
  text-transform: capitalize;
  color: var(--primary-hyperlink);
  svg {
    display: block;
  }
  div {
    color: #000;
  }

  @media screen and (max-width: 740px) {
    font-size: 12px;
    right: 12px;
  }
`;

export const CustomList = styled.ul`
  position: absolute;
  width: 100%;
  left: 0;
  top: 100%;
  z-index: 99;
  background: #ffff;
  text-align: left;
  padding: 16px;
  box-shadow: 3px 5px 5px 0px rgba(0, 0, 0, 0.5);
  border-radius: 4px;

  li {
    width: 100%;
    margin: 8px 0;
    cursor: pointer;
  }
`;